module.exports = __webpack_public_path__ + "static/media/settings-icons-white.cd468906.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/settings-icons-white.svg
// module id = 1229
// module chunks = 0